import { render } from "./AppPostList.html?vue&type=template&id=0d40cbe3"
import script from "./AppPostList.js?vue&type=script&lang=js"
export * from "./AppPostList.js?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__